import React from "react";
import { View, Text } from "@react-pdf/renderer";
import Styles from "../Styles";
import { LabelLineColumn, LabelLineRow } from "./FormFields";
import theme from "../../../../../../css/WhiteLabelledDocuments/theme";

const Notes = ({ primaryColor = "081e56" }) => {
  const styles = Styles(primaryColor);

  return (
    <View style={{ ...styles.FlexStartColumn, gap: 0 }}>
      <Text style={styles.LabelSmallSemiBold}>Notes</Text>
      <View
        style={{
          ...styles.panel,
          // backgroundColor: theme.colors.Black,
          width: 550,
        }}
      >
        <View style={styles.cols}>
          <LabelLineColumn styles={styles} label="" height={200} />
        </View>
      </View>
    </View>
  );
};


export default Notes;
